<template>

    <ui-sidebar-layout logo="logo-profmos">

        <ui-menu slot="menu">
            <ui-menu-group title="Overzicht"/>
            <ui-menu-item
                title="Per periode"
                icon="magicon-calendar"
                route="overview-period"
                v-if="$can('ROUTE_OVERVIEW_PERIOD')"/>
            <ui-menu-item
                title="Huidige partijen"
                icon="magicon-inbox"
                route="current-cohorts"
                v-if="$can('ROUTE_COHORTS')"/>
            <ui-menu-item
                title="Partij volgen"
                icon="magicon-jump-right-up"
                route="cohort-detail"
                v-if="$can('ROUTE_COHORT_DETAIL')"/>
            <ui-menu-item
                title="Water inzichten"
                icon="entypo-water"
                route="water-insights"
                v-if="$can('ROUTE_WATER_INSIGHTS')"/>

            <ui-menu-group title="Beheer"/>
            <ui-menu-item
                title="Mosselkwekers"
                icon="fa-building"
                route="growers"
                v-if="$can('ROUTE_GROWERS')"/> <!-- Admin only -->
            <ui-menu-item
                title="Schepen"
                icon="fa-ship"
                route="ships"
                v-if="$can('ROUTE_SHIPS')"/>
            <ui-menu-item
                title="Gebruikers"
                icon="fa-user-circle-o"
                route="users"
                v-if="$can('ROUTE_USERS')"/>
            <ui-menu-item
                title="Percelen"
                icon="magicon-resize-plus-3"
                route="parcels"
                v-if="$can('ROUTE_PARCELS')"/> <!-- Kweker only -->
            <ui-menu-item
                title="Vakken"
                icon="magicon-tiles"
                route="sections"
                v-if="$can('ROUTE_SECTIONS')"/> <!-- Kweker only -->

        </ui-menu>

        <div class="topbar-actions" slot="topbar-actions">
            <router-link class="account" :to="{ name: 'account' }">
                <i class="magicon-user"></i>
                <span>Mijn account</span>
            </router-link>
            <a href="#" class="help">
                <i class="entypo-help"></i>
            </a>
            <button type="button" class="logout" aria-label="Uitloggen" @click="logout">
                <i class="entypo-log-out"></i>
            </button>
        </div>

    </ui-sidebar-layout>

</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';

@Component({

    name: 'AppTemplate'
})
export default class AppTemplate extends Vue {

    logout() {

        this.$auth.logout();
    }
}

</script>